import {connect} from "react-redux";
import DealerActivityList from "./list";
import {bindActionCreators} from "redux";
import {activityList} from "../../../../service/Activity/action";
import {markAttendances, userCheckout, addTaggedAlong, ratingSave} from "../../../../service/Dealer/action";
import {errorLogs} from "../../../../service/FasttagToll/action";
const mapStateToProps = (state) => ({
    activityListDetails: state.Activity.activityList,
    isCheckoutDetails: state.Dealer.isCheckoutDetails,
    markAttendanceDetails: state.Dealer.markAttendance,
    addedTaggedAlong: state.Dealer.addedTaggedAlong,
    savedRating: state.Dealer.savedRating,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            activityList,
            markAttendances,
            userCheckout,
            addTaggedAlong,
            ratingSave,
            errorLogs
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(DealerActivityList);
